// frontend/admin-portal/src/components/orders/OrderExportMenu.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Dropdown, DropdownItem } from "@fiberhome/shared-ui";
import { orderService } from "../../services/orderService";

export default function OrderExportMenu({ order }) {
  const navigate = useNavigate();
  if (!order) return null;

  const handlePdf = async () => {
    try {
      await orderService.downloadPdf(order.id, order.code);
    } catch (err) {
      alert(err.response?.data?.message || err.message || "PDF failed");
    }
  };

  const handleExcel = async () => {
    try {
      await orderService.downloadExcel(order.id, order.code);
    } catch (err) {
      alert(err.response?.data?.message || err.message || "Excel failed");
    }
  };

  return (
    <Dropdown
      align="right"
      trigger={<Button variant="outline">Export ▾</Button>}
    >
      <DropdownItem onClick={() => navigate(`/orders/${order.id}/print`)}>
        🖨 Print / Preview (browser)
      </DropdownItem>
      <DropdownItem onClick={handlePdf}>📄 Download PDF (server)</DropdownItem>
      <DropdownItem onClick={handleExcel}>📊 Download Excel</DropdownItem>
    </Dropdown>
  );
}
